import { atom } from "jotai";

import { cultureAtom } from "./cultureAtom";
import {
  currentPreferencesAtom,
  type ThemePreference,
} from "./preferencesAtom";

/**
 * OS-level dark mode preference. Updated by a matchMedia listener
 * in ThemeProviderWrapper so it stays reactive.
 */
export const osDarkModeAtom = atom(
  typeof window !== "undefined"
    ? window.matchMedia("(prefers-color-scheme: dark)").matches
    : false,
);

/**
 * Writable tri-state theme preference: system | light | dark.
 * Reads from current persona preferences; writes update preferences storage.
 */
export const themePreferenceAtom = atom(
  (get): ThemePreference => get(currentPreferencesAtom).theme,
  (_get, set, preference: ThemePreference) => {
    set(currentPreferencesAtom, { theme: preference });
  },
);

/**
 * Resolved boolean: is dark mode active?
 * Resolves 'system' using the OS preference.
 */
export const darkModeAtom = atom((get) => {
  const preference = get(themePreferenceAtom);
  if (preference === "dark") return true;
  if (preference === "light") return false;
  return get(osDarkModeAtom);
});

export const isRTLAtom = atom((get) => get(cultureAtom) === "ar");
